import React from 'react'
import styled from 'styled-components'
import { FlexTabletRow } from '@styles/global/flexGrid'
import { ICurriculum } from '@et/types/Courses'
import { device } from '@styles/global/breakpoints'
import { useVideoStats } from '@hooks/useVideoStats'

interface IProps {
  curriculum: ICurriculum[]
  colors: {
    modules: string,
    videos: string,
    hours: string
  }
}

function VideoStats({ curriculum, colors }: IProps) {
  const { totalModules, totalVideos, totalMins } = useVideoStats(curriculum)
  return (
    <VideoStatsWrapper>
      <VideoStatItem color={colors.modules}>
        <Total>{totalModules}</Total>
        <Type>Modules</Type>
      </VideoStatItem>

      <VideoStatItem color={colors.videos}>
        <Total>{totalVideos}</Total>
        <Type>Videos</Type>
      </VideoStatItem>

      <VideoStatItem color={colors.hours}>
        <Total>{totalMins}</Total>
        <Type>Hours</Type>
      </VideoStatItem>

    </VideoStatsWrapper>
  )
}

const VideoStatsWrapper = styled(FlexTabletRow)`
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-bottom: 30px;
  flex-direction: row;
`
const Total = styled.span`
  text-align: center;
  display: block;
  font-size: 22px;
  
  @media ${device.tablet}{
    font-size: 38px;
  }
`
const Type = styled.span`
  text-align: center;
  display: block;
  font-weight: 600;
  font-size: 18px;
  
  @media ${device.tablet}{
    font-size: 21px;
  }
`

const VideoStatItem = styled.div<ITotalProps>`
  padding: 0 10px 20px;
  
  ${Total}, ${Type} {
    color: ${props => props.color};
  }
  
  @media ${device.tablet}{
    padding: 0 20px;
  
    &:first-child{
      border-right: 2px solid #bdbdbd;
    }
    &:last-child{
      border-left: 2px solid #bdbdbd;
    }
  }
`

interface ITotalProps {
  color: string
}

export default VideoStats
